import { Component, Input } from '@angular/core';
import { environment } from '@environments';

@Component({
  selector: 'app-each-app',
  templateUrl: './each-app.component.html'
})
export class EachAppComponent {
  @Input() appData: any;
}